const YANDEX_METRIKA_ID = 111032954
const GOOGLE_ANALYTICS_ID = 'G-C8Q17RQX24'

type YandexMetrikaQueue = ((...args: unknown[]) => void) & {
  a?: unknown[][]
  l?: number
}

export default defineNuxtPlugin(() => {
  useScriptGoogleAnalytics({ id: GOOGLE_ANALYTICS_ID })

  const scope = window as unknown as { ym?: YandexMetrikaQueue }

  const queue: YandexMetrikaQueue = scope.ym || function (...args: unknown[]) {
    (queue.a = queue.a || []).push(args)
  }
  queue.l = Date.now()
  scope.ym = queue

  queue(YANDEX_METRIKA_ID, 'init', {
    ssr: true,
    clickmap: true,
    ecommerce: 'dataLayer',
    referrer: document.referrer,
    url: location.href,
    accurateTrackBounce: true,
    trackLinks: true,
  })

  useScript(`https://mc.yandex.ru/metrika/tag.js?id=${YANDEX_METRIKA_ID}`, {
    trigger: 'onNuxtReady',
  })
})
